import type { RequireExactlyOne } from "type-fest"

import Paper from "@mui/material/Paper"
import type { PaperProps } from "@mui/material/Paper"
import { styled } from "@mui/material/styles"

// See https://mui.com/material-ui/guides/composition/#with-typescript
const StyledPaper = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(8),
}))

type WhiteBoxProps = RequireExactlyOne<PaperProps, "aria-labelledby">

export const WhiteBox = (props: WhiteBoxProps) => {
  return (
    <StyledPaper component="section" elevation={0} {...(props as PaperProps)}>
      {props.children}
    </StyledPaper>
  )
}
